module.exports = __webpack_public_path__ + "images/skewness-15-desktop.png";